import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import {
  Login,
  AddSales,
  Orders,
  Product,
  Users,
  BoardOne,
  Marketing,
  Welcome,
  SizesPage,
  ProvidersPage,
  CouriersPage,
  Auditing,
  Operations,
  CustomerService
} from "../pages";

import { MainLayout } from "../components";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

import { checkValueFirebase, mapDocs } from "../utils";
import { checkAccess } from "../access";
import { OrdersContextProvider } from "../context/OrdersContext";
import { BoardFour } from "../pages/BoardFour";
import { CouriersModulePage } from "../pages/Couriers/courierModulePage";

export const Routers = () => {
  const auth = getAuth();
  const db = getFirestore();

  const [user, setUser] = useState();

  useEffect(() => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        await checkValueFirebase(db, "user", "email", user.email, "data").then(
          (res) => {
            const userData = { ...mapDocs(res)[0] };
            setUser(userData);
          }
        );
      }
    });
  }, [auth, db]);

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={!user ? <Login /> : <Navigate to="/start" />}
        />

        <Route
          path="/users"
          element={
            !user || !checkAccess("users", user.role) ? (
              <Navigate to="/" />
            ) : (
              <MainLayout>
                {" "}
                <Users />
                {""}
              </MainLayout>
            )
          }
        />

        <Route
          path="/add-sales"
          element={
            user && checkAccess("sales", user.role) ? (
              <MainLayout>
                {" "}
                <AddSales />{" "}
              </MainLayout>
            ) : (
              <Navigate to="/" />
            )
          }
        />

        <Route
          path="/orders"
          element={
            user && checkAccess("orders", user.role) ? (
              <MainLayout>
                {" "}
                <Orders />{" "}
              </MainLayout>
            ) : (
              <Navigate to="/" />
            )
          }
        />

        <Route
          path="/tablero-ventas"
          element={
            user && checkAccess("salesStats", user.role) ? (
              <MainLayout>
                {" "}
                <OrdersContextProvider><BoardOne /></OrdersContextProvider>
              </MainLayout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/tablero-operaciones"
          element={
            user && checkAccess("operationStats", user.role) ? (
              <MainLayout>
                {" "}
                <OrdersContextProvider><Operations /></OrdersContextProvider>
              </MainLayout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/tablero-servicio-cliente"
          element={
            user && checkAccess("customerServiceRead", user.role) ? (
              <MainLayout>
                {" "}
                <OrdersContextProvider><CustomerService /></OrdersContextProvider>
              </MainLayout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/tablero-marketing"
          element={
            user && checkAccess("marketingStats", user.role) ? (
              <MainLayout>
                {" "}
                <OrdersContextProvider><Marketing /></OrdersContextProvider>
              </MainLayout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/tablero-finanzas"
          element={
            user && checkAccess("financeStats", user.role) ? (
              <MainLayout>
                {" "}
                <OrdersContextProvider><BoardFour /></OrdersContextProvider>
              </MainLayout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/product"
          element={
            user && checkAccess("products", user.role) ? (
              <MainLayout>
                {" "}
                <Product />{" "}
              </MainLayout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/start"
          element={
            !user ? (
              <Login />
            ) : (
              <MainLayout>
                {""}
                <Welcome
                  name={user.name}
                  surname={user.surname}
                  role={user.role}
                />
                {""}
              </MainLayout>
            )
          }
        />
        <Route
          path="/sizes"
          element={
            user && checkAccess("products", user.role) ? (
              <MainLayout>
                {""}
                <SizesPage />
                {""}
              </MainLayout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/providers"
          element={
            user && checkAccess("products", user.role) ? (
              <MainLayout>
                {""}
                <ProvidersPage />
                {""}
              </MainLayout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/couriers"
          element={
            user && checkAccess("products", user.role) ? (
              <MainLayout>
                {""}
                <CouriersPage />
                {""}
              </MainLayout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/auditing"
          element={
            user && checkAccess("auditing", user.role) ? (
              <MainLayout>
                {""}
                <Auditing />
                {""}
              </MainLayout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/couriersBoard"
          element={
            user && checkAccess("courierStats", user.role) ? (
              <MainLayout>
                {""}
                <OrdersContextProvider><CouriersModulePage /></OrdersContextProvider>
                {""}
              </MainLayout>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="*"
          element={!user ? <Login /> : <Navigate to="/start" />}
        />
      </Routes>
    </BrowserRouter>
  );
};
